import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PublishCampaignModalComponent } from '../publish-campaign-modal/publish-campaign-modal.component';
import { AppConfig } from 'src/app/core/configs/app.config';

@Component({
    selector: 'app-media-plan-overview',
    templateUrl: './media-plan-overview.component.html',
    styleUrls: ['./media-plan-overview.component.scss']
})
export class MediaPlanOverviewComponent implements OnInit {
    public playsLabels = ['1', '2', '3', '4', '5', '6', '7'];
    public playsData = [5600, 2355, 9230, 7356, 1856, 3983, 6666];

    public reachLabels = ['1', '2', '3', '4', '5', '6', '7'];
    public reachData = [2200, 1999, 6200, 8200, 3200, 3983, 4400];

    public constructor(public dialog: MatDialog) {}

    ngOnInit(): void {}

    public publishCampaign() {
        const dialogRef = this.dialog.open(PublishCampaignModalComponent, {
            width: AppConfig.dialog_width_xs,
            maxHeight: AppConfig.dialog_max_height,
            data: {}
        });
    }
}
